import { jsPDF } from "jspdf";
// autoTable tidak lagi digunakan untuk bagian utama, namun bisa dipertahankan jika ada kebutuhan lain
// import autoTable from "jspdf-autotable";

// === HELPER: Konversi angka ke terbilang (Indonesia) ===
const terbilang = (n) => {
  if (n < 0) return "minus " + terbilang(-n);
  const ang = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas"];
  if (n < 12) return ang[n];
  if (n < 20) return ang[n - 10] + " belas";
  if (n < 100) return ang[Math.floor(n / 10)] + " puluh " + ang[n % 10];
  if (n < 200) return "seratus " + terbilang(n - 100);
  if (n < 1000) return ang[Math.floor(n / 100)] + " ratus " + terbilang(n % 100);
  if (n < 2000) return "seribu " + terbilang(n - 1000);
  if (n < 1000000) return terbilang(Math.floor(n / 1000)) + " ribu " + terbilang(n % 1000);
  if (n < 1000000000) return terbilang(Math.floor(n / 1000000)) + " juta " + terbilang(n % 1000000);
  if (n < 1000000000000) return terbilang(Math.floor(n / 1000000000)) + " miliar " + terbilang(n % 1000000000);
  return terbilang(Math.floor(n / 1000000000000)) + " triliun " + terbilang(n % 1000000000000);
};

const capitalize = (str) => {
  if (!str) return "";
  return str.replace(/\b\w/g, char => char.toUpperCase()).replace(/\s+/g, " ").trim();
};

const formatNumber = (num) => {
  if (num == null || isNaN(num)) return "";
  return new Intl.NumberFormat("id-ID").format(num);
};

const formatDate = (val) => {
  if (!val) return "-";
  try {
    const date = new Date(val);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    return "-";
  }
};

const totalNominal = (d) => {
  if (!d) return 0;
  return (
    (d.spokok || 0) +
    (d.swajib || 0) +
    (d.smanasuka || 0) +
    (d.shariraya || 0) +
    (d.lainlain || 0) +
    (d.dpha || 0) +
    (d.piutang_d || 0) +
    (d.angsuran_d || 0) +
    (d.jasa_d || 0) +
    (d.germen_d || 0) +
    (d.svoucher || 0) +
    (d.piutang_c || 0) +
    (d.angsuran_c || 0) +
    (d.jasa_c || 0) +
    (d.germen_c || 0)
  );
};

const TransaksiUmum = (data) => {
  if (!data) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const d = Array.isArray(data) ? data[0] : data;
  if (!d) {
    alert("Data transaksi kosong.");
    return;
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [148, 210] // width x height mm
  });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 12;
  const rightCol = pageWidth - margin;
  const rightMargin = 12;
  const rightEdge = pageWidth - rightMargin;

  const labelRightX = rightEdge - 45;  // label rata kiri
  const colonRightX = rightEdge - 22;  // titik dua fix
  const valueRightX = rightEdge;       // value rata kanan

  // === Header ===
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("KPRI SRI REJEKI", margin, 15);
  doc.text("BKM", pageWidth / 2, 15, { align: "center" });
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("4094/BH/11/78", margin, 22);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Bukti Kas Masuk", pageWidth / 2, 22, { align: "center" });

  doc.line(margin, 27, rightCol, 27);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  // No. Transaksi
  doc.text("No. Transaksi", labelRightX, 15);
  doc.text(":", colonRightX, 15);
  doc.text(d.notransaksi || "-", valueRightX, 15, { align: "right" });

  // Tanggal
  doc.text("Tanggal", labelRightX, 22);
  doc.text(":", colonRightX, 22);
  doc.text(formatDate(d.tgltransak), colonRightX + 3, 22);

  // === Info utama ===
  let y = 35;
  const total = totalNominal(d);
  const terbilangText = capitalize(terbilang(total)) + " Rupiah";
  
  const labelX = margin;
  const colonX = margin + 50;
  const valueX = margin + 55;

  doc.text(`Diterima dari`, labelX, y);
  doc.text(`:`, colonX, y);
  doc.text(`${d.nama || "-"}`, valueX, y);
  y += 7;
  doc.text(`Banyaknya Uang`,labelX, y);
  doc.text(`:`,colonX, y);
  doc.text(`Rp. ${formatNumber(total)} ,-`, valueX, y);  
  y += 7;
  doc.text("Terbilang", labelX, y);
  doc.text(`:`, colonX, y);
  doc.setFont("helvetica", "italic");
  doc.text(terbilangText,valueX, y, { maxWidth: pageWidth - margin - 25 });
  doc.setFont("helvetica", "normal");

  // Garis pemisah atas
  y += 5;
  doc.line(margin, y, rightCol, y);
  y += 8;

  // === Rincian Transaksi Manual ===
  const col1X = margin;
  const col2X = margin + 75;
  const col3X = margin + 135;
  
  const valueCol1X = col1X + 50;
  const valueCol2X = col2X + 45;
  const valueCol3X = col3X + 45;
  
  const lineHeight = 7;
  
  const items = [
    { c1: "Simpanan Pokok", v1: d.spokok, c2: "Piutang D", v2: d.piutang_d, c3: "Piutang C", v3: d.piutang_c },
    { c1: "Simpanan Wajib", v1: d.swajib, c2: "Angsuran", v2: d.angsuran_d, c3: "Angsuran", v3: d.angsuran_c },
    { c1: "Simpanan Manasuka", v1: d.smanasuka, c2: "Jasa", v2: d.jasa_d, c3: "Jasa", v3: d.jasa_c },
    { c1: "Simpanan Hariraya", v1: d.shariraya, c2: "Germen", v2: d.germen_d, c3: "Germen", v3: d.germen_c },
    { c1: "Lain - lain", v1: d.lainlain, c2: "Voucher Belanja", v2: d.svoucher, c3: null, v3: null },
    { c1: "DPHA", v1: d.dpha, c2: null, v2: null, c3: null, v3: null },
  ];

  items.forEach(row => {
    if (row.c1) {
    doc.text(row.c1, col1X, y);
    doc.text(formatNumber(row.v1), valueCol1X, y, { align: 'right' });
    }
    if (row.c2) {
    doc.text(row.c2, col2X, y);
    doc.text(formatNumber(row.v2), valueCol2X, y, { align: 'right' });
    }
    if (row.c3) {
    doc.text(row.c3, col3X, y);
    doc.text(formatNumber(row.v3), valueCol3X, y, { align: 'right' });
    }
    y += lineHeight;
  });

  // Tambahkan garis pemisah di bawah DPHA
  y += 1;
  doc.line(margin, y, rightCol, y);
  y += 8;

  // === Tanda tangan ===
  y += 15;
  
  // Garis di atas Bendahara
  doc.line(margin, y, margin + 40, y);
  y += 7;
  doc.text("Bendahara", margin + 20, y, { align: "center" });
  

  doc.line(pageWidth / 2 - 20, y - 7, pageWidth / 2 + 20, y - 7);
  doc.text("Kasir", pageWidth / 2, y, { align: "center" });
  
  // Garis di atas Penyetor
  doc.line(rightCol - 40, y - 7, rightCol, y - 7);
  doc.text("Penyetor", rightCol - 20, y, { align: "center" });

  // === Output PDF ===
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};

export default TransaksiUmum;